import { createReducer, on } from '@ngrx/store';
import { NAME_IN_LEGEND_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setScatterPlot } from '../scatter-plot.actions';
import { setNameInLegend } from './chart-options.actions';
export const nameInLegend = createReducer(NAME_IN_LEGEND_DEFAULT, on(setNameInLegend, (state, action) => {
    return action.nameInLegend;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot[ScatterPlotChartOptionValue.nameInLegend];
}));
